// ============================================================
// MOONSHINE MASTERS — text.js        THE WORDS (Sun Dial words page: src/data/text.json)
//
// Every line the mission board says that caP'n might reword lives in data/text.json: {lines:{key:text}, lists:{key:[text]}}.
// The Sun Dial edits that file; data/text.original.json is the untouched factory copy.
//   say(key, {vars})  - an edited line wins, even a BLANK one (blank stays blank); a key that is missing falls back to the factory copy.
//   listOf(key, min)  - the edited list (blank items dropped); if it has fewer than `min` items the factory list is used instead,
//                       so a list the game cannot run without can never go empty.
// {tokens} in a line are filled from vars; an unknown token is left as it is. Pure - no React, no Date.
// ============================================================
import RAW from "./data/text.json";
import FACTORY from "./data/text.original.json";

const own = (o, k) => !!o && Object.prototype.hasOwnProperty.call(o, k);
const fill = (t, vars) => String(t).replace(/\{(\w+)\}/g, (m, k) => (vars && own(vars, k) ? String(vars[k]) : m));
export function say(key, vars) {
  const t = own(RAW.lines, key) && typeof RAW.lines[key] === "string" ? RAW.lines[key] : own(FACTORY.lines, key) ? FACTORY.lines[key] : key;
  return fill(t, vars);
}
export const hasLine = (key) => own(RAW.lines, key) || own(FACTORY.lines, key);
const clean = (a) => (Array.isArray(a) ? a.filter((x) => typeof x === "string" && x.trim()) : []);
export function listOf(key, min = 1) {
  const mine = own(RAW.lists, key) ? clean(RAW.lists[key]) : [];
  if (mine.length >= min) return mine;
  const f = own(FACTORY.lists, key) ? clean(FACTORY.lists[key]) : [];
  return f;
}
